import React from "react";

export default function Error() {
  return <div>page not found</div>;
}
